import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Form from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { newsletterRevealAnimation } from './animations'
import { cn } from '@/lib/utils'
import { WPGravityForm, WPImage } from '@/types'

export type NewsletterProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  background_image: WPImage
  form: WPGravityForm
}

const Newsletter = ({ title, background_image, form, ...props }: NewsletterProps) => {
  return (
    <Motion animation={newsletterRevealAnimation}>
      <Section
        {...props}
        style={{ backgroundImage: `url(${background_image?.url})`, backgroundSize: 'cover' }}
      >
        <Container>
          <Grid>
            <div className="col-span-4 flex flex-col items-center justify-center gap-spacing-sm pb-spacing-xs pt-spacing-2xl md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-4">
              <Typography variant="h5" className="text-center text-text-primary-dark">
                {title}
              </Typography>
              {form?.id ? (
                <Form
                  form_id={form.id.toString()}
                  fields={form?.fields}
                  submit={form?.button?.text}
                  className={cn(
                    '!flex w-full flex-wrap items-center justify-center gap-spacing-xxs',
                    // Input email
                    '[&>div:nth-child(1)] [&>div:nth-child(1)]:order-1 [&>div:nth-child(1)]:flex-[1_1_100%] md:[&>div:nth-child(1)]:flex-[1_1_auto]',
                    '[& pb-spacing-xs_[type="email"]]:font-roboto [&_[type="email"]]focus:ring-error/50 [&_[type="email"]:error]:border-error/50 [&_[type="email"]]:h-[43px] [&_[type="email"]]:rounded-[8px] [&_[type="email"]]:border-transparent [&_[type="email"]]:bg-surface-primay-invert-light [&_[type="email"]]:!py-spacing-xs [&_[type="email"]]:px-4 [&_[type="email"]]:pt-2 [&_[type="email"]]:text-text-primary-invert-dark [&_[type="email"]]:placeholder:text-text-primary-light/50',
                    // Privacy checkbox
                    '[&>div:nth-child(2)]:order-3 [&>div:nth-child(2)]:h-[43px] [&>div:nth-child(2)]:flex-[1_1_100%]',
                    '[&>div:nth-child(2)_svg]:!fill-surface-secondary-invert-light',
                    '[&>div:nth-child(2)_span]:!ml-spacing-sm md:[&>div:nth-child(2)_span]:!ml-spacing-xs',
                    // Submit button
                    '[&>div:nth-child(3)]:!order-2 [&>div:nth-child(3)]:!mt-0 [&>div:nth-child(3)]:!flex-[1_1_100%] md:[&>div:nth-child(3)]:!flex-[0_1_auto]',
                    '[&_[type="submit"]]:h-[43px] [&_[type="submit"]]:rounded-[8px] [&_[type="submit"]]:px-spacing-md [&_[type="submit"]]:py-2 [&_[type="submit"]]:font-roboto [&_[type="submit"]]:text-text-primary-dark md:[&_[type="submit"]]:!w-auto [&_[type="submit"]_.icon]:hidden [&_[type="submit"]_span]:text-text-primary-dark',
                    '[&_[type="submit"]]:rounded-[0.8rem] [&_[type="submit"]]:bg-gradient-to-l [&_[type="submit"]]:from-[#5B949F] [&_[type="submit"]]:to-[#32555C]',
                    'md:[&_.spinner]:right-[1rem] [&_.status-message]:mt-0 [&_[type="submit"]>span:last-child]:hidden',
                    // Feedback Text
                    '[&>div:nth-child(4)]:order-4 [&>div:nth-child(4)]:flex-[0_1_100%]'
                  )}
                />
              ) : null}
            </div>
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default Newsletter
